import './pickup.css';
export default function Pickup({ data }) {
    const mapUrlPattern = /^https?:\/\/(?:www\.)?maps\.app\.goo\.gl\/([A-Za-z0-9_-]{11,17})(?:[\/?].*)?$/i;
    function OpenInNewIcon({ size = 24, color = 'currentColor' }) {
        return (
            <svg xmlns='http://www.w3.org/2000/svg' height={size} viewBox='0 0 24 24' width={size} fill={color}>
                <path d='M0 0h24v24H0z' fill='none' />
                <path d='M14 3v2h3.59L10 12.59 11.41 14 19 6.41V10h2V3h-7z' />
                <path d='M5 5v14h14v-7h-2v5H7V7h5V5H5z' />
            </svg>
        );
    }
    const handleLink = (link) => {
        const pattern = mapUrlPattern.test(link);
        return pattern ? link : undefined;
    };
    return (
        <div>
            <div className='detailsIncludedDiv'>
                <div>
                    <p className='tagsNoteP'>Note: click on location name to get exact map loaction</p>
                </div>
                {/* <TripDetailsSubHeading text={'Included'} /> */}
                <div className='includedpoints'>
                    <ul>
                        {data?.map((inc, incIndex) => {
                            return (
                                <li key={incIndex} className='incText location'>
                                    <a
                                        href={handleLink(inc.location)}
                                        className='locationLink'
                                        target='_blank'
                                        rel='noopener noreferrer'
                                        onClick={(e) => {
                                            if (!mapUrlPattern.test(inc.location)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    >
                                        {inc.name}
                                        <OpenInNewIcon size={18} color='orange' />{' '}
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </div>
    );
}
